import '../../styles/style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { LineChart } from '@mui/x-charts/LineChart';
import HeaderBar from './HeaderBar';
import { useTheme } from './ThemeContext';
import { useData } from './MemberData';
import { useState, useEffect, useRef } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import Cookies from 'js-cookie';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import Swal from 'sweetalert2';
import axios from 'axios';

let myDiscordID = ''
interface Member {
    user_id: number;
    full_name: string;
    callsign: number;
    rank: string;
    entry_date: string | Date;
    last_up: string | Date;
    discordID: string;
    functions?: Record<string, boolean | string>;
    certificates?: Record<string, boolean | string>;
    fw: number;
    notes: string;
    grade: string;
    reintegrated: boolean;
    email: string;
}

interface Logs{
    type: string;
    member: string;
    pType: string;
    date_time: string;
}

interface Demisie{
    callsign: number;
    id: number;
    rank: string;
    reason: string;
}

interface Concediu{
    callsign: number;
    name: string;
    startDate: string;
    endDate: string;
    reason: string;    
    status: Boolean;
}

interface ActivityData{
    callsign: number;
    days: string;
    report: string
}

interface Invoire{
    callsign: number;
    reason: string;
    status: Boolean;
}

interface Contestatie{
    callsign: number;
    tip: string;
    nume: string;
    dovada: string;
    tipcontestatie: string;
}

function HomePage() {      
    const { theme } = useTheme();
    const { membersData, getMemberInfo, refreshAccessToken, getDiscordMemberInfo } = useData();
    const [Cmembers, setCmembers] = useState(0);
    const [logsHR, setLogs] = useState<Logs[]>([]);
    const [openConcediu, setOpenConcediu] = useState(false);
    const [openDemisie, setOpenDemisie] = useState(false);
    const [openInvoire, setOpenInvoire] = useState(false);
    const [activeFines, setActiveFines] = useState(0);
    const [isConducere, setIsConducere] = useState(false);
    const [id, setID] = useState(0);
    const [grad, setGrad] = useState("");
    const [nume, setNume] = useState("");
    const [callsign, setCallsign] = useState("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [reason, setReason] = useState("");
    const [myData, setMyData] = useState<Member | null>(null);
    const [activeDemisiiOpen, setActiveDemisiiOpen] = useState(false);
    const [activeDemisii, setDemisiiActive] = useState<Demisie[]>([])
    const [activeConcediiOpen, setActiveConcediiOpen] = useState(false);
    const [activeConcedii, setConcediiActive] = useState<Concediu[]>([]);
    const [data, setData] = useState<number[]>([0, 0, 0, 0, 0, 0, 0]);
    const [activeInvoiriOpen, setActiveInvoiriOpen] = useState(false);
    const [activeInvoiri, setActiveInvoiri] = useState<Invoire[]>([]);

    useEffect(() => {
        let conducereCount = 0;
        let isConducereTemp = false;
        myDiscordID = Cookies.get('myDiscordID') || '';
        if (myDiscordID === '') {
            let email = Cookies.get('email');
            for (let index = 0; index < membersData.length; index++) {
                const element = membersData[index];
                if (element.email === email) {
                    Cookies.set("myDiscordID", element.discordID)
                    myDiscordID = element.discordID
                    setMyData(element)
                }
            }
        }
        for (let index = 0; index < membersData.length; index++) {
            const member = membersData[index];
            if (member.discordID === myDiscordID) {
                setMyData(member);
            }
            if (member.grade === "Director-General" || member.grade === "Director-Adjunct" || member.grade === "Medic-Inspector" || member.grade === "Medic-Chirurg") {
                conducereCount++;
                if (member.discordID === myDiscordID) {
                    isConducereTemp = true;
                }
            }
        }
        
        const updateGraph = async () => {
            try {
                const response = await axios.get<ActivityData[]>(
                    `http://panelmedici.fplayt.ro:5000/api/activityByCS?callsign=${getDiscordMemberInfo(myDiscordID, "callsign")}`
                );
                if (response.data[0]) {
                    response.data[0].days = JSON.parse(response.data[0].days).map((day: string | null) => {
                        return (day === null || day === "-" || day === "CO") ? 0 : Number(day);
                    });
                    setData([Number(response.data[0].days[0]), Number(response.data[0].days[1]), Number(response.data[0].days[2]), Number(response.data[0].days[3]), Number(response.data[0].days[4]), Number(response.data[0].days[5]), Number(response.data[0].days[6])]);
                    saveToLocalStorage("timerData", [Number(response.data[0].days[0]), Number(response.data[0].days[1]), Number(response.data[0].days[2]), Number(response.data[0].days[3]), Number(response.data[0].days[4]), Number(response.data[0].days[5]), Number(response.data[0].days[6])]);
                } else {
                    setData([0,0,0,0,0,0,0])
                }
            } catch (err) {
                console.log(err)
                toast.error("A aparut o eroare la actualizarea graficului!");
            }
        }
        
        updateGraph();
        checkFines();
        loadHRLogs();
        setCmembers(conducereCount);
        setIsConducere(isConducereTemp);
    }, [membersData]);

    async function loadHRLogs() {
        try {
            const response = await axios.get(`http://panelmedici.fplayt.ro:5000/api/getHRLogs`);
            if (response.data) {
                setLogs(response.data.reverse());
            } else {
                return;
            }
        } catch (err) {
            console.log(err);
        }
    }

    async function checkFines() {
        try {
            const response = await axios.get(`http://panelmedici.fplayt.ro:5000/api/punishmentsData`);
            const members_punishments = response.data;
            if (members_punishments && Array.isArray(members_punishments)) {
                let finesCount = 0; 
                for (let index = 0; index < members_punishments.length; index++) {
                    const element = members_punishments[index];
                    if (JSON.parse(element.punishments)?.status === false && JSON.parse(element.punishments)?.pType === "AMENDA") {
                        finesCount++;
                    }
                }
                setActiveFines(finesCount);
            } else {
                console.warn('No data found in members_punishments.');
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Amenzile active nu au fost incarcate!");
        }
    }
    
    const concediuStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#202020' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };

    const demisieStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#202020' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };

    const invoireStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '30%',
        height: '35%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#202020' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };

    const activeStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45%',
        height: '60%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#191919' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };    

    const contestatieStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45%',
        height: '70%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#191919' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    }

    const activeCStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height: '60%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === 'dark' ? '#191919' : 'white',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 4,
    };    

    
    function openConcediuModal() {
        setOpenConcediu(true);
    }

    function openDemisieModal() {
        setOpenDemisie(true);
    }

    function openInvoireModal() {
        setOpenInvoire(true);
    }

    async function openDemisiiModal() {
        try {
            const response = await axios.get(`http://panelmedici.fplayt.ro:5000/api/getActiveDemisii`);
            if (response.data) {
                setDemisiiActive(response.data);
                setActiveDemisiiOpen(true);
            } else {
                return;
            }
        } catch (err) {
            console.log(err);
        }
    }

    const rejectDemisie = async (callsign: number) => {
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/requests/rejectDemisie", {
                    callsign: callsign
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText === "OK") {
                    toast.error("Ai sters cererea de demisie!");
                    openDemisiiModal();
                } else {
                    toast.error("A aparut o eroare! Concediul nu a fost respins!");
                }
            } catch (err) {
                if ((err as any).response && (err as any).response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
    
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
    
                        const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/requests/rejectDemisie", {
                            callsign: callsign
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        if (retryResponse.statusText === "OK") {
                            toast.error("Ai sters cererea de demisie!");
                            openDemisiiModal();
                        } else {
                            toast.error("A aparut o eroare! Concediul nu a fost respins!");
                        }
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A aparut o eroare! Concediul nu a fost respins!");
                }
            }
        } catch (error) {
            console.log(error);
            toast.error("A aparut o eroare! Concediul nu a fost respins!");
        }
    }
    
    const handleDemisiiClose = () => {
        setActiveDemisiiOpen(false);
    }
    
    const handleCloseModal = () => {
        setOpenConcediu(false);
        setOpenDemisie(false);
        setOpenInvoire(false);
    };

    const validateConcediuForm = () => {
        let isValid = true;
    
        if (!callsign.trim() && !startDate && !endDate && !reason.trim()) {
            toast.error("Toate campurile sunt obligatorii!");
            isValid = false;
        }
    
        const normalizeDate = (date: string | number | Date) => {
            const newDate = new Date(date);
            newDate.setHours(0, 0, 0, 0);
            return newDate;
        };
    
        const today = normalizeDate(new Date());
        const start = startDate ? normalizeDate(startDate) : null;
        const end = endDate ? normalizeDate(endDate) : null;
    
        if (start && start < today) {
            toast.error("Data incepere inactivitate nu poate fi in trecut!");
            isValid = false;
        }
    
        if (end && end < today) {
            toast.error("Data incheiere concediu nu poate fi in trecut!");
            isValid = false;
        }
    
        if (start && end && start > end) {
            toast.error("Data incepere inactivitate nu poate fi dupa Data incheiere concediu!");
            isValid = false;
        }
    
        return isValid;
    };    

    const handleConcediuSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (validateConcediuForm()) {
            if (Number(callsign) === Number(getDiscordMemberInfo(myDiscordID, "callsign"))) {
                const formData = {
                    callsign: callsign,
                    startDate: startDate?.toLocaleDateString('ro-RO', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }),
                    endDate: endDate?.toLocaleDateString('ro-RO', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }),
                    reason: reason,
                };
                try {
                    let token = Cookies.get("accessToken");
                    if (!token) {
                        toast.error("Nu ai un token de acces valabil!");
                        return;
                    }
    
                    try {
                        await axios.post("http://panelmedici.fplayt.ro:5000/requests/concediu", {
                            callsign: Number(callsign),
                            name: getMemberInfo(Number(callsign), "full_name"),
                            startDate: startDate?.toLocaleDateString('ro-RO', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            }),
                            stopDate: endDate?.toLocaleDateString('ro-RO', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            }),
                            reason: reason,
                            formData: formData
                        }, { headers: { Authorization: `Bearer ${token}` } });
    
                        handleCloseModal();
                        toast.success("Cererea ta a fost trimisa catre conducere!");
                    } catch (err) {
                        if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                            let refreshToken = Cookies.get("refreshToken");
                            if (!refreshToken) {
                                toast.error("Nu ai un refresh token valabil!");
                                return;
                            }
    
                            const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                                refreshToken: refreshToken
                            });
    
                            if (refreshResponse.status === 200) {
                                const newAccessToken = refreshResponse.data.accessToken;
                                Cookies.set("accessToken", newAccessToken);
    
                                await axios.post("http://panelmedici.fplayt.ro:5000/requests/concediu", {
                                    callsign: Number(callsign),
                                    name: getMemberInfo(Number(callsign), "full_name"),
                                    startDate: startDate?.toLocaleDateString('ro-RO', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }),
                                    stopDate: endDate?.toLocaleDateString('ro-RO', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }),
                                    reason: reason,
                                    formData: formData
                                }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                                handleCloseModal();
                                toast.success("Cererea ta a fost trimisa catre conducere!");
                            } else {
                                toast.error("Refresh token-ul nu este valid!");
                            }
                        } else {
                            toast.error("A aparut o eroare! Cererea de concediu nu a fost trimisa!");
                        }
                    }
                } catch (err) {
                    console.log(err);
                    toast.error("A aparut o eroare! Cererea de concediu nu a fost trimisa!");
                }
            } else {
                toast.error("Nu poti face o cerere de concediu pe alt callsign!");
            }
        }
    };
    
    const handleDemisieSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
    
        if (Number(callsign) === Number(getDiscordMemberInfo(myDiscordID, "callsign"))) {
            const formData = {
                callsign: callsign,
                nume: nume,
                user_id: id,
                grad: grad,
                reason: reason,
                entry_date: getMemberInfo(Number(callsign), "entry_date")
            };
            try {
                let token = Cookies.get("accessToken");
                if (!token) {
                    toast.error("Nu ai un token de acces valabil!");
                    return;
                }
    
                try {
                    await axios.post("http://panelmedici.fplayt.ro:5000/requests/demisie", {
                        callsign: Number(callsign),
                        user_id: id,
                        rank: grad,
                        reason: reason,
                        formData: formData
                    }, { headers: { Authorization: `Bearer ${token}` } });
    
                    handleCloseModal();
                    toast.success("Cererea ta a fost trimisa catre conducere!");
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                        let refreshToken = Cookies.get("refreshToken");
                        if (!refreshToken) {
                            toast.error("Nu ai un refresh token valabil!");
                            return;
                        }
    
                        const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                            refreshToken: refreshToken
                        });
    
                        if (refreshResponse.status === 200) {
                            const newAccessToken = refreshResponse.data.accessToken;
                            Cookies.set("accessToken", newAccessToken);
                            await axios.post("http://panelmedici.fplayt.ro:5000/requests/demisie", {
                                callsign: Number(callsign),
                                user_id: id,
                                rank: grad,
                                reason: reason,
                                formData: formData
                            }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                            handleCloseModal();
                            toast.success("Cererea ta a fost trimisa catre conducere!");
                        } else {
                            toast.error("Refresh token-ul nu este valid!");
                        }
                    } else {
                        toast.error("A aparut o eroare! Cererea de demisie nu a fost trimisa!");
                    }
                }
            } catch (err) {
                console.log(err);
                toast.error("A aparut o eroare! Cererea de demisie nu a fost trimisa!");
            }
        } else {
            toast.error("Nu poti face o cerere de demisie pe alt callsign!");
        }
    };
    
    const handleInvoireSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (Number(callsign) === Number(getDiscordMemberInfo(myDiscordID, "callsign"))) {
            const formData = {
                callsign: callsign,
                reason: reason,
            };
            try {
                let token = Cookies.get("accessToken");
                if (!token) {
                    toast.error("Nu ai un token de acces valabil!");
                    return;
                }
    
                try {
                    await axios.post("http://panelmedici.fplayt.ro:5000/requests/invoire", {
                        callsign: callsign,
                        reason: reason,
                        formData: formData
                    }, { headers: { Authorization: `Bearer ${token}` } });
    
                    handleCloseModal();
                    toast.success("Cererea ta a fost trimisa catre conducere!");
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                        let refreshToken = Cookies.get("refreshToken");
                        if (!refreshToken) {
                            toast.error("Nu ai un refresh token valabil!");
                            return;
                        }
    
                        const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                            refreshToken: refreshToken
                        });
    
                        if (refreshResponse.status === 200) {
                            const newAccessToken = refreshResponse.data.accessToken;
                            Cookies.set("accessToken", newAccessToken);
    
                            await axios.post("http://panelmedici.fplayt.ro:5000/requests/invoire", {
                                callsign: callsign,
                                reason: reason,
                                formData: formData
                            }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                            handleCloseModal();
                            toast.success("Cererea ta a fost trimisa catre conducere!");
                        } else {
                            toast.error("Refresh token-ul nu este valid!");
                        }
                    } else {
                        toast.error("A aparut o eroare! Cererea nu a fost trimisa.");
                    }
                }
            } catch (err) {
                console.log(err);
                toast.error("A aparut o eroare! Cererea nu a fost trimisa.");
            }
        } else {
            toast.error("Nu poti face o cerere de invoire pe alt callsign!");
        }
    };
    

    const handleConcediiOpen = async () => {
        try {
            const response = await axios.get("http://panelmedici.fplayt.ro:5000/get/concedii");
            if (response) {
                if (response.data) {
                    setConcediiActive(response.data);
                }
                setActiveConcediiOpen(true);
            } else {
                toast.error("Nicio cerere de concediu activa!")
                return;
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Cererile de concediu nu au fost incarcate!");
        }
    }

    const autofillActivityData = async (callsign: number, startDate: string, endDate: string, reason: string) => {
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/requests/acceptConcediu", {
                    callsign: callsign,
                    reason: reason
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText === "OK") {
                    toast.success("Ai acceptat concediul!");
                } else {
                    toast.error("A aparut o eroare! Concediul nu a fost sters dar a fost trecut!");
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
    
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
                        const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/requests/acceptConcediu", {
                            callsign: callsign,
                            reason: reason
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        if (retryResponse.statusText === "OK") {
                            toast.success("Ai acceptat concediul!");
                        } else {
                            toast.error("A aparut o eroare! Concediul nu a fost sters dar a fost trecut!");
                        }
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A aparut o eroare! Concediul nu a fost sters dar a fost trecut!");
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Concediul nu a fost sters dar a fost trecut!");
        }
    
        handleConcediiOpen();
    };
    

    const acceptConcediu = async (callsign: number, startDate: string, endDate: string, reason: string) => {
        autofillActivityData(callsign, startDate, endDate, reason);
        handleConcediiOpen();
    }

    const rejectConcediu = async (callsign: number, reason: string) => {
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/requests/rejectConcediu", {
                    callsign: callsign,
                    reason: reason
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText === "OK") {
                    toast.error("Ai respins cererea de concediu!");
                    handleConcediiOpen();
                } else {
                    toast.error("A aparut o eroare! Concediul nu a fost respins!");
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
    
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
                        const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/requests/rejectConcediu", {
                            callsign: callsign,
                            reason: reason
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        if (retryResponse.statusText === "OK") {
                            toast.error("Ai respins cererea de concediu!");
                            handleConcediiOpen();
                        } else {
                            toast.error("A aparut o eroare! Concediul nu a fost respins!");
                        }
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A aparut o eroare! Concediul nu a fost respins!");
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Concediul nu a fost respins!");
        }
    };
    
    
    const handleConcediiClose = () => {
        setActiveConcediiOpen(false);
    }
    
    const [startTime, setStartTime] = useState<number | null>(null);
    const [isRunning, setIsRunning] = useState<boolean>(false);
    const [elapsedTime, setElapsedTime] = useState<number>(0);
    const [canOpenDuty, setOpenDuty] = useState(true);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    
    const getCurrentDayIndex = () => {
      const day = new Date().getDay();
      return day === 0 ? 6 : day - 1; 
    };
    
    const loadInitialState = () => {
      const savedStartTime = localStorage.getItem("startTime");
      const savedElapsedTime = localStorage.getItem("elapsedTime");
      const savedIsRunning = localStorage.getItem("isRunning") === "true";
      const savedData = localStorage.getItem("timerData");
    
      if (savedStartTime && savedIsRunning) {
        const now = Date.now();
        const elapsed = Math.floor((now - Number(savedStartTime)) / 1000);
        setStartTime(Number(savedStartTime));
        setIsRunning(true);
        setElapsedTime(elapsed); 
      } else if (savedElapsedTime) {
        setElapsedTime(Number(savedElapsedTime));
      }
    
      if (savedData) {
        setData(JSON.parse(savedData));
      }
    };
    
    const saveToLocalStorage = (key: string, value: any) => {
      localStorage.setItem(key, JSON.stringify(value));
    };
    
    useEffect(() => {
      loadInitialState(); 
    
      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }, []);
    
    useEffect(() => {
      if (isRunning && startTime !== null) {
        intervalRef.current = setInterval(() => {
          setElapsedTime((prev) => prev + 1); 
        }, 1000);
      } else if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    
      return () => {
        if (intervalRef.current) clearInterval(intervalRef.current); 
      };
    }, [isRunning, startTime]);
    
    const startTimer = async () => {
        if (canOpenDuty === false) {
            toast.error("Asteapta sa ti se salveze pontajul!");
            return;
        }
        if (Boolean(localStorage.getItem("isRunning")) === true) return;
        const now2 = Date.now();
        const currentDayIndex = getCurrentDayIndex();
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            try {
                await axios.post("http://panelmedici.fplayt.ro:5000/duty/start", {
                    callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                    dayIndex: currentDayIndex,
                    status: "running",
                }, { headers: { Authorization: `Bearer ${token}` } });
                setStartTime(now2);
                setIsRunning(true);
                saveToLocalStorage("startTime", now2);
                saveToLocalStorage("isRunning", true);
                saveToLocalStorage("dayIndex", currentDayIndex);
                toast.success("Ai pornit pontajul!");
            } catch (err) {
                if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
    
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
                        await axios.post("http://panelmedici.fplayt.ro:5000/duty/start", {
                            callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                            dayIndex: currentDayIndex,
                            status: "running",
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                        setStartTime(now2);
                        setIsRunning(true);
                        saveToLocalStorage("startTime", now2);
                        saveToLocalStorage("isRunning", true);
                        saveToLocalStorage("dayIndex", currentDayIndex);
                        toast.success("Ai pornit pontajul!");
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A apărut o eroare! Nu s-a putut salva timpul de început.");
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("A apărut o eroare! Nu s-a putut salva timpul de început.");
        }
    };

    const stopTimer = async () => {
        if (!isRunning || startTime === null) return;
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa inchizi pontajul?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de oprire a pontajului!");
            return;
        } else {
            setOpenDuty(false);
            const now = Date.now();
            const currentElapsedTime = Math.floor((now - startTime) / 1000);
            const roundedMinutes = Math.round(currentElapsedTime / 60);
            const currentDayIndex = getCurrentDayIndex();
    
            setIsRunning(false);
            saveToLocalStorage("elapsedTime", 0);
            saveToLocalStorage("isRunning", false);
            let token = Cookies.get("accessToken");
    
            if (roundedMinutes < 30) {
                try {
                    await axios.post("http://panelmedici.fplayt.ro:5000/duty/stop", {
                        callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                        dayIndex: localStorage.getItem("dayIndex"),
                        status: "min"
                    }, { headers: { Authorization: `Bearer ${token}` } });
                    setStartTime(null);
                    toast.error("Pontajul minim de 30 minute nu a fost îndeplinit! Acesta nu va fi luat in considerare.");
                    return;
                } catch (err) {
                    toast.error("A apărut o eroare la ștergerea pontajului.");
                }
                setElapsedTime(0);
                return;
            }
    
            setStartTime(null);
            const updatedData = [...data];
            updatedData[currentDayIndex] += roundedMinutes;
    
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/duty/stop", {
                    callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                    dayIndex: currentDayIndex,
                    status: "ok"
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.data.msg === "OK") {
                    setData(updatedData);
                    saveToLocalStorage("timerData", updatedData);
                    toast.success("Pontajul a fost salvat!");
                    setOpenDuty(true);
                } else if (response.data.msg === "CANCELED") {
                    toast.error("Pontajul ti-a fost anulat! Acesta nu a fost salvat.");
                } else {
                    toast.error("A apărut o eroare! Pontajul nu a fost salvat.");
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
    
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
    
                        const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/duty/stop", {
                            callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                            dayIndex: currentDayIndex,
                            status: "ok"
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        if (retryResponse.data.msg === "OK") {
                            setData(updatedData);
                            saveToLocalStorage("timerData", updatedData);
                            toast.success("Pontajul a fost salvat!");
                            setOpenDuty(true);
                        } else if (retryResponse.data.msg === "CANCELED") {
                            toast.error("Pontajul ti-a fost anulat! Acesta nu a fost salvat.");
                        } else {
                            toast.error("A apărut o eroare! Pontajul nu a fost salvat.");
                        }
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A apărut o eroare! Pontajul nu a fost salvat.");
                }
            }
            setElapsedTime(0);
        }
    };
    
    
    const formatTime = (seconds: number) => {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${hours} ore, ${minutes} minute, și ${secs} secunde`;
    };
    
    const deleteHRHistory = async () => {
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa stergi istoricul HR?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de stergere istoric!");
            return;
        } else {
            try {
                let token = Cookies.get("accessToken");
                if (!token) {
                    toast.error("Nu ai un token de acces valabil!");
                    return;
                }
    
                try {
                    const response = await axios.post('http://panelmedici.fplayt.ro:5000/deleteHistory', {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    if (response.statusText === "OK") {
                        toast.success("Istoricul a fost sters!");
                        setLogs([]);
                    } else {
                        toast.error("A aparut o eroare! Istoricul nu a fost sters.");
                    }
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                        let refreshToken = Cookies.get("refreshToken");
                        if (!refreshToken) {
                            toast.error("Nu ai un refresh token valabil!");
                            return;
                        }
    

                        const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                            refreshToken: refreshToken
                        });
    
                        if (refreshResponse.status === 200) {
                            const newAccessToken = refreshResponse.data.accessToken;
                            Cookies.set("accessToken", newAccessToken);
                            const retryResponse = await axios.post('http://panelmedici.fplayt.ro:5000/deleteHistory', {}, {
                                headers: { Authorization: `Bearer ${newAccessToken}` }
                            });
                            if (retryResponse.statusText === "OK") {
                                toast.success("Istoricul a fost sters!");
                                setLogs([]);
                            } else {
                                toast.error("A aparut o eroare! Istoricul nu a fost sters.");
                            }
                        } else {
                            toast.error("Refresh token-ul nu este valid!");
                        }
                    } else {
                        toast.error("A aparut o eroare! Istoricul nu a fost sters.");
                    }
                }
            } catch (err) {
                console.log(err);
                toast.error("A aparut o eroare! Istoricul nu a fost sters.");
            }
        }
    };
    

    const handleInvoiriOpen = async () => {
        try {
            const response = await axios.get('http://panelmedici.fplayt.ro:5000/get/invoiri');
            if (response) {
                setActiveInvoiri(response.data);
                setActiveInvoiriOpen(true);
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Pagina de invoiri nu s-a putut deschide.");
        }
    }

    const handleInvoiriClose = () => {
        setActiveInvoiriOpen(false);
    }

    const acceptInvoire = async (callsign: number) => {
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/requests/acceptInvoire", {
                    callsign: callsign
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText) {
                    handleInvoiriOpen();
                    toast.success("Cererea de invoire a fost acceptata!");
                } else {
                    toast.error("A aparut o eroare! Invoirea nu a fost acceptata.");
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
                        const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/requests/acceptInvoire", {
                            callsign: callsign
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        if (retryResponse.statusText) {
                            handleInvoiriOpen();
                            toast.success("Cererea de invoire a fost acceptata!");
                        } else {
                            toast.error("A aparut o eroare! Invoirea nu a fost acceptata.");
                        }
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A aparut o eroare! Invoirea nu a fost acceptata.");
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Invoirea nu a fost acceptata.");
        }
    };
    
    const rejectInvoire = async (callsign: number) => {
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            try {
                const response = await axios.post("http://panelmedici.fplayt.ro:5000/requests/rejectInvoire", {
                    callsign: callsign
                }, { headers: { Authorization: `Bearer ${token}` } });
    
                if (response.statusText) {
                    handleInvoiriOpen();
                    toast.success("Cererea de invoire a fost respinsa!");
                } else {
                    toast.error("A aparut o eroare! Invoirea nu a fost respinsa.");
                }
            } catch (err) {
                if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                    let refreshToken = Cookies.get("refreshToken");
                    if (!refreshToken) {
                        toast.error("Nu ai un refresh token valabil!");
                        return;
                    }
    
                    const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                        refreshToken: refreshToken
                    });
    
                    if (refreshResponse.status === 200) {
                        const newAccessToken = refreshResponse.data.accessToken;
                        Cookies.set("accessToken", newAccessToken);
                        const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/requests/rejectInvoire", {
                            callsign: callsign
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        if (retryResponse.statusText) {
                            handleInvoiriOpen();
                            toast.success("Cererea de invoire a fost respinsa!");
                        } else {
                            toast.error("A aparut o eroare! Invoirea nu a fost respinsa.");
                        }
                    } else {
                        toast.error("Refresh token-ul nu este valid!");
                    }
                } else {
                    toast.error("A aparut o eroare! Invoirea nu a fost respinsa.");
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Invoirea nu a fost respinsa.");
        }
    };
    
    const [contestatieModalOpen, setContestatieModalOpen] = useState(false);
    const [contestatieType, toggleContestatieType] = useState("test");
    const [contestatieTest, setTestContest] = useState("");
    const [contestatieAmenda, setAmendaContestatie] = useState("");
    const [testerName, setTesterName] = useState("");
    const [contestatieDovada, setContestatieDovada] = useState("");
    const [activeContestatii, setActiveContestatii] = useState<Contestatie[]>([]);
    const [activeContestatiiModalOpen, setActiveContestatiiModalOpen] = useState(false);
    
    const openContestatieModal = () => {
        setContestatieModalOpen(true);
    }

    const handleContestatiiClose = () => {
        setContestatieModalOpen(false);
        setTestContest("");
        setTesterName("");
        setAmendaContestatie("");
        setContestatieDovada("");
    }

    const sendContestatie = async () => {
        if (contestatieType === "test") {
            if (contestatieTest !== "" && testerName !== "" && contestatieDovada !== "") {
                let token = Cookies.get("accessToken");
                if (!token) {
                    toast.error("Nu ai un token de acces valabil!");
                    return;
                }
    
                try {
                    const response = await axios.post("http://panelmedici.fplayt.ro:5000/contestatie/test", {
                        callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                        tip: contestatieTest,
                        nume: testerName,
                        dovada: contestatieDovada
                    }, { headers: { Authorization: `Bearer ${token}` } });
    
                    if (response.statusText === "OK") {
                        toast.success("Contestatia a fost trimisa catre conducere!");
                        handleContestatiiClose();
                    } else {
                        toast.error("A aparut o eroare! Contestatia nu a fost trimisa.");
                    }
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                        let refreshToken = Cookies.get("refreshToken");
                        if (!refreshToken) {
                            toast.error("Nu ai un refresh token valabil!");
                            return;
                        }
    
                        const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                            refreshToken: refreshToken
                        });
    
                        if (refreshResponse.status === 200) {
                            const newAccessToken = refreshResponse.data.accessToken;
                            Cookies.set("accessToken", newAccessToken);
                            const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/contestatie/test", {
                                callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                                tip: contestatieTest,
                                nume: testerName,
                                dovada: contestatieDovada
                            }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                            if (retryResponse.statusText === "OK") {
                                toast.success("Contestatia a fost trimisa catre conducere!");
                                handleContestatiiClose();
                            } else {
                                toast.error("A aparut o eroare! Contestatia nu a fost trimisa.");
                            }
                        } else {
                            toast.error("Refresh token-ul nu este valid!");
                        }
                    } else {
                        toast.error("A aparut o eroare! Contestatia nu a fost trimisa.");
                    }
                }
            } else {
                toast.error("Toate campurile sunt obligatorii!");
                return;
            }
        } else {
            if (contestatieAmenda !== "" && testerName !== "" && contestatieDovada !== "") {
                let token = Cookies.get("accessToken");
                if (!token) {
                    toast.error("Nu ai un token de acces valabil!");
                    return;
                }
    
                try {
                    const response = await axios.post("http://panelmedici.fplayt.ro:5000/contestatie/amenda", {
                        callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                        tip: contestatieAmenda,
                        nume: testerName,
                        dovada: contestatieDovada
                    }, { headers: { Authorization: `Bearer ${token}` } });
    
                    if (response.statusText === "OK") {
                        toast.success("Contestatia a fost trimisa catre conducere!");
                        handleContestatiiClose();
                    } else {
                        toast.error("A aparut o eroare! Contestatia nu a fost trimisa.");
                    }
                } catch (err) {
                    if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                        let refreshToken = Cookies.get("refreshToken");
                        if (!refreshToken) {
                            toast.error("Nu ai un refresh token valabil!");
                            return;
                        }
    
                        const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                            refreshToken: refreshToken
                        });
    
                        if (refreshResponse.status === 200) {
                            const newAccessToken = refreshResponse.data.accessToken;
                            Cookies.set("accessToken", newAccessToken);
                            const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/contestatie/amenda", {
                                callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                                tip: contestatieAmenda,
                                nume: testerName,
                                dovada: contestatieDovada
                            }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                            if (retryResponse.statusText === "OK") {
                                toast.success("Contestatia a fost trimisa catre conducere!");
                                handleContestatiiClose();
                            } else {
                                toast.error("A aparut o eroare! Contestatia nu a fost trimisa.");
                            }
                        } else {
                            toast.error("Refresh token-ul nu este valid!");
                        }
                    } else {
                        toast.error("A aparut o eroare! Contestatia nu a fost trimisa.");
                    }
                }
            } else {
                toast.error("Toate campurile sunt obligatorii!");
                return;
            }
        }
    };
    

    const handleContestatiiOpen = async () => {
        try {
            const response = await axios.get("http://panelmedici.fplayt.ro:5000/contestatie/get");
            if (response && response.data) {
                setActiveContestatii(response.data || []);
            }
        } catch (err) {
            console.log(err);
            toast.error("A aparut o eroare! Lista nu s-a putut incarca.")
        }
        setActiveContestatiiModalOpen(true);
    }

    const handleActiveContestatiiClose = () => {
        setActiveContestatiiModalOpen(false);
    }

    const deleteContestatie = async (callsign: number, tip: string, tipcontestatie: string, nume: string) => {
        let token = Cookies.get("accessToken");
        if (!token) {
            toast.error("Nu ai un token de acces valabil!");
            return;
        }
    
        try {
            const response = await axios.post("http://panelmedici.fplayt.ro:5000/contestatie/delete", {
                callsign: callsign,
                tip: tip,
                tipcontestatie: tipcontestatie,
                nume: nume
            }, { headers: { Authorization: `Bearer ${token}` } });
    
            if (response.statusText === "OK") {
                toast.success("Contestatie stearsa cu succes!");
                handleContestatiiOpen();
            } else {
                toast.error("A aparut o eroare! Contestatia nu a fost stearsa.");
            }
        } catch (err) {
            if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                let refreshToken = Cookies.get("refreshToken");
                if (!refreshToken) {
                    toast.error("Nu ai un refresh token valabil!");
                    return;
                }
                const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                    refreshToken: refreshToken
                });
                if (refreshResponse.status === 200) {
                    const newAccessToken = refreshResponse.data.accessToken;
                    Cookies.set("accessToken", newAccessToken);
                    const retryResponse = await axios.post("http://panelmedici.fplayt.ro:5000/contestatie/delete", {
                        callsign: callsign,
                        tip: tip,
                        tipcontestatie: tipcontestatie,
                        nume: nume
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                    if (retryResponse.statusText === "OK") {
                        toast.success("Contestatie stearsa cu succes!");
                        handleContestatiiOpen();
                    } else {
                        toast.error("A aparut o eroare! Contestatia nu a fost stearsa.");
                    }
                } else {
                    toast.error("Refresh token-ul nu este valid!");
                }
            } else {
                toast.error("A aparut o eroare! Contestatia nu a fost stearsa.");
            }
        }
    };
    

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className={`${theme} w-full h-full flex flex-col gap-3 box-border`}>
                <HeaderBar currentPage="Pagina Principala"/>
                <div className="w-full h-[87%] box-border pr-[1%] pb-[1%] flex flex-row justify-between">
                    <div className="w-[49.8%] h-full flex flex-col gap-[1%]">
                        <div className="w-full h-[20%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex items-center justify-center gap-[1%]">
                            <div className="w-[31.6%] h-[88%] bg-white dark:bg-[#323232] rounded-[.5vw] flex flex-col items-center">
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[1.2vw] mt-[1%]">Cadre Medicale</span>
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[4vw] mt-[-2%]">{membersData.length}<span className="text-[#7E7E7E] textRegular text-[1vw]">/150</span></span>
                            </div>
                            <div className="w-[31.6%] h-[88%] bg-white dark:bg-[#323232] rounded-[.5vw] flex flex-col items-center">
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[1.2vw] mt-[1%]">Membri CONDUCERE</span>
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[4vw] mt-[-2%]">{Cmembers}<span className="text-[#7E7E7E] textRegular text-[1vw]">{Cmembers > 10 ? `/${Cmembers}` : "/10"}</span></span>
                            </div>
                            <div className="w-[31.6%] h-[88%] bg-white dark:bg-[#323232] rounded-[.5vw] flex flex-col items-center">
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[1.2vw] mt-[1%]">Amenzi ACTIVE</span>
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[4vw] mt-[-2%]">{activeFines}</span>
                            </div>
                        </div>
                        <div className="w-full h-[22%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <span className="w-full h-[20%] flex items-center justify-center textBold text-[#323232] dark:text-[#ffffff] text-[1vw]">Cereri Inactivitate/Demisie</span>
                            <div className="w-[97%] h-[75%] gap-[1%] bg-white dark:bg-[#323232] rounded-[.8vw] flex items-center justify-center">
                                <div onClick={openConcediuModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CERERE CONCEDIU</span>
                                </div>
                                <div onClick={openDemisieModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#d80f0f] to-[#f51818] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CERERE DEMISIE</span>
                                </div>
                                <div onClick={openInvoireModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CERERE INVOIRE</span>
                                </div>
                                <div onClick={openContestatieModal} className="cursor-pointer w-[23%] h-[60%] pl-[5%] pr-[5%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                    <span className="textBold text-white text-[1.1vw] text-center">CONTESTATIE</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full h-[56%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <div className="w-[97%] h-[15%] flex items-center justify-between">
                                <span className="textSemiBold text-[#323232] dark:text-[#ffffff] text-[1vw]">Calculator Pontaje</span>
                                <div className="w-[40%] h-[80%] flex items-center justify-end gap-[2%]">
                                    <button onClick={startTimer} disabled={isRunning} className="bg-[#3CD03488] w-[42%] h-[80%] rounded-full flex items-center justify-center gap-[5%] cursor-pointer">
                                        <FontAwesomeIcon className="text-white text-[1vw]" icon={faStopwatch} />
                                        <span className="textRegular text-white text-[0.9vw]">ON-DUTY</span>
                                    </button>
                                    <button onClick={stopTimer} disabled={!isRunning} className="bg-[#D0343488] w-[42%] h-[80%] rounded-full flex items-center justify-center gap-[5%] cursor-pointer">
                                        <FontAwesomeIcon className="text-white text-[0.9vw]" icon={faClock} />
                                        <span className="textRegular text-white text-[0.9vw]">OFF-DUTY</span>
                                    </button>
                                </div>
                            </div>
                            <div className="w-[97%] h-[83%] bg-white dark:bg-[#323232] rounded-[0.9vw] flex flex-col box-border p-[1.5%]">
                                <span className="textBold text-[#323232] dark:text-[#ffffff] text-[1vw]">Pontaj activ: {formatTime(elapsedTime)}</span>
                                <LineChart
                                    xAxis={[
                                        {
                                            scaleType: "band",
                                            data: ["Luni", "Marti", "Miercuri", "Joi", "Vineri", "Sambata", "Duminica"],
                                        },
                                    ]}
                                    series={[
                                        {
                                            data: data,
                                            area: true,
                                            color: "orange",
                                        },
                                    ]}
                                    sx={{
                                        [`.${axisClasses.root}`]: {
                                          [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                                            stroke: theme === "dark" ? '#ffffff' : "#000000",
                                            strokeWidth: 1,
                                          },
                                          [`.${axisClasses.tickLabel}`]: {
                                            fill: theme === "dark" ? '#ffffff' : "#000000",
                                          },
                                        },
                                        "& .MuiAreaElement-root": {
                                          fill: "url(#darkGradient)",
                                        }
                                      }}
                                    slotProps={{ legend: { hidden: true } }} 
                                    className="w-full h-full"
                                />
                            <svg width={0} height={0}>
                                    <defs>
                                        <linearGradient id="lightGradient" x1="0" y1="0" x2="1" y2="0">
                                            <stop offset="0%" stopColor="#D99564" /> 
                                            <stop offset="100%" stopColor="#F6BF79" /> 
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <svg width={0} height={0}>
                                    <defs>
                                        <linearGradient id="darkGradient" x1="0" y1="0" x2="1" y2="0">
                                            <stop offset="0%" stopColor="#D8630F" /> 
                                            <stop offset="100%" stopColor="#F59318" /> 
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="w-[49.8%] h-full flex flex-col justify-between">
                        <div className="w-full h-[50%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex items-center justify-center">
                            <div className="w-[97%] h-[93%] bg-white dark:bg-[#323232] rounded-[0.9vw] flex items-center justify-center gap-[0.5%]">
                                <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                                    <span className="textSemiBold text-[1.2vw] mt-[1%] text-center text-[#000000] dark:text-white">Atribuții</span>
                                    <div className="w-full h-full flex flex-col text-base">
                                        {myData?.functions ? (
                                            (() => {
                                                const functions = typeof myData.functions === 'string' 
                                                    ? JSON.parse(myData.functions) 
                                                    : myData.functions; 
                                                return Object.entries(functions).map(([key, value]) => (
                                                    <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                                                        <span className="textSemiBold text-[1vw] text-[#323232] dark:text-white">
                                                            {key.charAt(0).toUpperCase() + key.slice(1)} {/* Capitalize the first letter */}
                                                        </span>
                                                        <span className="textSemiBold gradient-text text-[1vw]">
                                                            {typeof value === 'string' ? value : value ? 'DA' : 'NU'} {/* Handle boolean and string values */}
                                                        </span>
                                                    </div>
                                                ));
                                            })()
                                        ) : (
                                            <div className="textMedium text-[#323232] dark:text-white text-[1vw] w-full h-full flex items-center justify-center">
                                                Nu ai nicio functie atribuita.
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="w-[1px] h-[90%] bg-[#929292]"></div>
                                <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                                    <span className="textSemiBold text-[1.2vw] mt-[1%] text-center text-[#000000] dark:text-white">Certificate</span>
                                    <div className="w-full h-full flex flex-col items-center text-base">
                                        {myData?.certificates ? (
                                            (() => {
                                                const certificates = typeof myData.certificates === 'string' 
                                                    ? JSON.parse(myData.certificates) 
                                                    : myData.certificates;
                                                return Object.entries(certificates).map(([key, value]) => (
                                                    <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                                                        <span className="textSemiBold text-[1vw] text-[#323232] dark:text-white">
                                                            {key.charAt(0).toUpperCase() + key.slice(1)} {/* Capitalize the first letter */}
                                                        </span>
                                                        <span className="textSemiBold gradient-text text-[1vw]">
                                                            {typeof value === 'string' ? value : value ? 'DA' : 'NU'} {/* Handle boolean and string values */}
                                                        </span>
                                                    </div>
                                                ));
                                            })()
                                        ) : (
                                            <div className="textMedium text-[#323232] dark:text-white text-[1vw] w-full h-full flex items-center justify-center">
                                                Nu ai niciun certificat.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full h-[18%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <span className="w-full h-[25%] flex items-center justify-center textBold text-[#323232] dark:text-[#ffffff] text-[1vw]">Cereri Active</span>
                            <div className="w-[97%] h-[70%] bg-white dark:bg-[#323232] rounded-[.8vw] flex items-center justify-center gap-[1%]">
                                {isConducere ? (
                                    <>
                                        <div onClick={handleConcediiOpen} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CERERI CONCEDIU</span>
                                        </div>
                                        <div onClick={openDemisiiModal} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#d80f0f] to-[#f51818] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CERERI DEMISIE</span>
                                        </div>
                                        <div onClick={handleInvoiriOpen} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CERERI INVOIRI</span>
                                        </div>
                                        <div onClick={handleContestatiiOpen} className="cursor-pointer w-[23.5%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                            <span className="textBold text-white text-[1.1vw] text-wrap text-center">CONTESTATII</span>
                                        </div>
                                    </>
                                ) : myData?.functions?.['responsabil concedii'] === true ? (
                                    <div onClick={handleConcediiOpen} className="cursor-pointer w-[45%] h-[70%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                        <span className="textBold text-white text-[1.3vw]">CERERI CONCEDIU</span>
                                    </div>
                                ) : (
                                    <span className="text-[#323232] dark:text-white textSemiBold text-[1vw]">Nu ai acces sa vezi aceasta sectiune!</span>
                                )}
                            </div>
                        </div>
                        <div className="w-full h-[30%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] backdrop-blur-[32px] rounded-[1vw] flex flex-col items-center">
                            <span className="w-full h-[15%] flex items-center justify-center textBold text-[#323232] dark:text-[#ffffff] text-[1vw]">Istoric Actiuni</span>
                            {isConducere === true && (
                                <div onClick={deleteHRHistory} className="cursor-pointer absolute right-[2%] top-[2.5%] px-[2%] bg-gradient-to-r from-[#d80f0f] to-[#f51818] rounded-[.2vw]">
                                    <span className="textMedium text-white text-[0.7vw]">Sterge Istoric</span>
                                </div>
                            )}
                            <div className="w-[97%] h-[81%] bg-white dark:bg-[#323232] rounded-[.8vw] flex flex-col items-center overflow-y-scroll">
                                {logsHR.map((log, index) => (
                                    log.type === "SANCTIUNE" ? (
                                        <div key={index} className="w-full min-h-[20%] border-b-[1px] border-[#D0D0D0] flex flex-row items-center justify-between box-border pl-[2%] pr-[2%] gap-[2%]">
                                            <div className="w-[65%] h-full flex items-center gap-[2%]">
                                                <span className="textBold gradient-text text-[1.1vw] min-w-fit">
                                                SANCTIUNE: <span className="stop-gradient textSemiBold background-none text-black dark:text-white text-[1vw]">{log.member}</span>
                                                </span>
                                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                                <span className="textMedium text-[0.8vw] min-w-fit text-[#797979]">{log.date_time}</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div key={index} className="w-full min-h-[20%] border-b-[1px] border-[#D0D0D0] flex flex-row items-center justify-between box-border pl-[2%] pr-[2%] gap-[2%]">
                                            <div className="w-[70%] h-full flex items-center gap-[2%]">
                                                <span className={`textBold ${log.type === "ADMITERE" ? "text-[#0fd830]" : log.type === "UPDATE ATRIBUTII" ? "text-[#d8c10f]" : "text-[#d80f0f]"} text-[1.1vw] min-w-fit`}>
                                                {log.type}: <span className="textSemiBold text-black dark:text-white text-[1vw]">{log.member}</span>
                                                </span>
                                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                                <span className="textMedium text-[0.8vw] min-w-fit text-[#797979]">{log.date_time}</span>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>                        
                    </div>
                </div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openConcediu}
                    onClose={handleCloseModal}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={openConcediu}>
                    <Box sx={concediuStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">CERERE CONCEDIU</span>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                if (!startDate || !endDate) {
                                    toast.error("Completeaza datele de incepere/terminare a concediului!")
                                    return;
                                }
                                handleConcediuSubmit(e);
                            }}
                            className="w-full h-full flex items-center flex-col gap-[5%] box-border pt-[2%]"
                            >
                            <TextField
                                required
                                id="standard-required"
                                label="Callsign (ex: 520)"
                                variant="standard"
                                value={callsign}
                                onChange={(e) => setCallsign(e.target.value)}
                                className="w-[50%]"
                                sx={{
                                "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray",
                                },
                                "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray",
                                },
                                "& .MuiInput-underline:before": {
                                    borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)",
                                },
                                "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange", 
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                },
                                }}
                            />
                            <DatePicker
                                className="w-[50%]"
                                value={startDate ? dayjs(startDate) : null}
                                onChange={(date: Dayjs | null) => setStartDate(date ? date.toDate() : null)}
                                sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                    borderColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)",
                                    },
                                    "&:hover fieldset": {
                                    borderColor: theme === "dark" ? "lightgray" : "black",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: "orange", 
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray",
                                },
                                "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                },
                                "& .MuiSvgIcon-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiSvgIcon-root": {
                                    color: "orange", 
                                },
                                }}
                                format="DD/MM/YYYY"
                                label="Data incepere inactivitate"
                            />
                            <DatePicker
                                className="w-[50%]"
                                value={endDate ? dayjs(endDate) : null}
                                onChange={(date: Dayjs | null) => setEndDate(date ? date.toDate() : null)}
                                sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                    borderColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "&:hover fieldset": {
                                    borderColor: theme === "dark" ? "lightgray" : "black", 
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: "orange",
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                },
                                "& .MuiSvgIcon-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiSvgIcon-root": {
                                    color: "orange", 
                                },
                                }}
                                format="DD/MM/YYYY"
                                label="Data incheiere concediu"
                            />
                            <TextField
                                required
                                id="standard-required"
                                label="Motiv OOC"
                                variant="standard"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                className="w-[50%]"
                                sx={{
                                "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                },
                                "& .MuiInput-underline:before": {
                                    borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)",
                                },
                                "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange",
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                },
                                }}
                            />
                            <button
                                type="submit"
                                className="mt-[5%] textBold cursor-pointer w-fit h-[30%] pl-[15%] pr-[15%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]"
                            >
                                <span className="text-[1.1vw] text-white">TRIMITE CERERE</span>
                            </button>
                            </form>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openDemisie}
                    onClose={handleCloseModal}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={openDemisie}>
                    <Box sx={demisieStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">CERERE DEMISIE</span>
                        <form onSubmit={handleDemisieSubmit} className="w-full h-full flex items-center flex-col gap-[2%] box-border pt-[2%]">
                            <TextField
                                required
                                id="standard-required"
                                label="Nume"
                                onChange={(e) => setNume(e.target.value)}
                                variant="standard"
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "orange",
                                    },
                                }}
                            />
                            <TextField
                                required
                                id="standard-required"
                                label="Callsign (ex: 520)"
                                onChange={(e) => setCallsign(e.target.value)}
                                variant="standard"
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "orange",
                                    },
                                }}
                            />
                            <TextField
                                required
                                id="standard-required"
                                label="Grad"
                                onChange={(e) => setGrad(e.target.value)}
                                variant="standard"
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "orange",
                                    },
                                }}
                            />
                            <TextField
                                required
                                id="standard-required"
                                label="ID"
                                type="text" 
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setID(value === "" ? 0 : parseInt(value, 10));                                    
                                    }
                                }}
                                value={id}
                                variant="standard"
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                    borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                    },
                                }}
                                />
                            <TextField
                                required
                                id="standard-required"
                                label="Motiv"
                                onChange={(e) => setReason(e.target.value)}
                                variant="standard"
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                        borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                        borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                        color: "orange", 
                                    },
                                }}
                            />
                            <button type="submit" className="mt-[5%] textBold cursor-pointer w-fit h-[30%] pl-[15%] pr-[15%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                <span className="text-[1.1vw] text-white">TRIMITE CERERE</span>
                            </button>
                        </form>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={openInvoire}
                    onClose={handleCloseModal}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={openInvoire}>
                    <Box sx={invoireStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">CERERE INVOIRE</span>
                        <form onSubmit={handleInvoireSubmit} className="w-full h-full flex items-center flex-col gap-[2%] box-border pt-[2%]">
                            <TextField
                                required
                                id="standard-required"
                                label="Callsign (ex: 505)"
                                variant="standard"
                                onChange={(e) => setCallsign(e.target.value)}
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                    borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                    },
                                }}
                            />
                            <TextField
                                required
                                id="standard-required"
                                label="Motiv OOC"
                                variant="standard"
                                onChange={(e) => setReason(e.target.value)}
                                className="w-[50%]"
                                sx={{
                                    "& .MuiInputBase-input": {
                                    color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInputLabel-root": {
                                    color: theme === "dark" ? "white" : "gray", 
                                    },
                                    "& .MuiInput-underline:before": {
                                    borderBottomColor: theme === "dark" ? "gray" : "rgba(0, 0, 0, 0.42)", 
                                    },
                                    "& .MuiInput-underline:after": {
                                    borderBottomColor: "orange", 
                                    },
                                    "& .MuiInputLabel-root.Mui-focused": {
                                    color: "orange", 
                                    },
                                }}
                            />
                            <button type="submit" className="mt-[5%] textBold cursor-pointer w-fit h-[30%] pl-[15%] pr-[15%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                <span className="text-[1.1vw] text-white">TRIMITE CERERE</span>
                            </button>
                        </form>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeDemisiiOpen}
                    onClose={handleDemisiiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeDemisiiOpen}>
                    <Box sx={activeStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">LISTA DEMISII ACTIVE</span>
                        <div className="w-[100%] h-full bg-white dark:bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%]">
                        {activeDemisii.map((demisie, index) => (
                            <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]">
                                <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">M-{String(demisie.callsign).padStart(3, '0')}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{getMemberInfo(demisie.callsign, "full_name")}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                {demisie.reason.length > 15 ? (
                                    <div onClick={() => toast.info(`Motiv: ${demisie.reason}`)} className="w-[20%] h-[70%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0e75c4] to-[#18abf5]">
                                        <span className="textBold text-white text-[.8vw]">MOTIV</span>
                                    </div>
                                ) : (
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{demisie.reason}</span>
                                )}
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <div onClick={() => rejectDemisie(demisie.callsign)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                    <span className="textBold text-white text-[.8vw]">STERGE</span>
                                </div>
                            </div>
                        ))}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeConcediiOpen}
                    onClose={handleConcediiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeConcediiOpen}>
                    <Box sx={activeCStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">LISTA CERERI CONCEDII ACTIVE</span>
                        <div className="w-[100%] h-full bg-white dark:bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%] overflow-y-scroll">
                            {Array.isArray(activeConcedii) && activeConcedii.length > 0 && (
                                activeConcedii.map((concediu, index) => (
                                    <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]">
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">M-{String(concediu.callsign).padStart(3, '0')}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{concediu.name}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{concediu.startDate}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{concediu.endDate}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    {concediu.reason.length > 15 ? (
                                        <div onClick={() => toast.info(`Motiv: ${concediu.reason}`)} className="w-[20%] h-[70%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0e75c4] to-[#18abf5]">
                                            <span className="textBold text-white text-[.8vw]">MOTIV</span>
                                        </div>
                                    ) : (
                                        <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{concediu.reason}</span>
                                    )}
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    {Boolean(concediu.status) === true ? (
                                        <>
                                            <span className="textBold text-[#0ec423] text-[.8vw]">ACCEPTAT</span>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                            <div onClick={() => rejectConcediu(concediu.callsign, concediu.reason)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">STERGE</span>
                                            </div>
                                        </>
                                    ): (
                                        <>
                                            <div className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0ec423] to-[#18f532]">
                                                <span onClick={() => acceptConcediu(concediu.callsign, concediu.startDate, concediu.endDate, concediu.reason)} className="textBold text-white text-[.8vw]">ACCEPTA</span>
                                            </div>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                            <div onClick={() => rejectConcediu(concediu.callsign, concediu.reason)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">RESPINGE</span>
                                            </div>
                                        </>
                                    )}
                                    </div>
                                ))
                            )}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeInvoiriOpen}
                    onClose={handleInvoiriClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeInvoiriOpen}>
                    <Box sx={activeStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">LISTA INVOIRI ACTIVE</span>
                        <div className="w-[100%] h-full bg-white dark:bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%] overflow-y-scroll overflow-x-scroll">
                            {Array.isArray(activeInvoiri) && activeInvoiri.length > 0 && (
                                activeInvoiri.map((invoire, index) => (
                                <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]" >
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">M-{String(invoire.callsign).padStart(3, '0')}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{getMemberInfo(invoire.callsign, "full_name")}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    {invoire.reason.length > 15 ? (
                                        <div onClick={() => toast.info(`Motiv: ${invoire.reason}`)} className="w-[20%] h-[70%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0e75c4] to-[#18abf5]">
                                            <span className="textBold text-white text-[.8vw]">MOTIV</span>
                                        </div>
                                    ) : (
                                        <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{invoire.reason}</span>
                                    )}
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    {invoire.status ? (
                                        <>
                                            <span className="textBold text-[#0ec423] text-[.8vw] cursor-pointer">ACCEPTAT</span>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                            <div onClick={() => rejectInvoire(invoire.callsign)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">STERGE</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div onClick={() => acceptInvoire(invoire.callsign)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0ec423] to-[#18f532]">
                                                <span className="textBold text-white text-[.8vw]">ACCEPTA</span>
                                            </div>
                                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                            <div onClick={() => rejectInvoire(invoire.callsign)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">RESPINGE</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )))}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={contestatieModalOpen}
                    onClose={handleContestatiiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={contestatieModalOpen}>
                    <Box sx={contestatieStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">Depune Contestatie</span>
                        <div className="w-[100%] h-full bg-white dark:bg-[#282828] rounded-[0.5vw] flex flex-col items-center justify-center gap-[0.5%]">
                            <div className="w-full h-[10%] flex flex-row items-center justify-center gap-[5%]">
                                <span onClick={() => toggleContestatieType("test")} className={`contestatieSpan ${contestatieType === "test" && "active"} cursor-pointer textBold text-black dark:text-white text-[1.3vw]`}>TEST</span>
                                <span onClick={() => toggleContestatieType("amenda")} className={`contestatieSpan ${contestatieType === "amenda" && "active"} cursor-pointer textBold text-black dark:text-white text-[1.3vw]`}>AMENDA</span>
                            </div>
                            {contestatieType === "test" ? (
                                <div className="w-full h-[72%] flex flex-col items-center justify-center">
                                    <span className="textSemiBold text-black dark:text-white text-[1vw]">Tipul testului:</span>
                                    <div onClick={() => setTestContest("smuls")} className="w-[15%] h-[8%] flex flex-row items-center justify-between mt-[1%]">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">SMULS</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieTest === "smuls" && "active"} rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setTestContest("pilot")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">PILOT</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieTest === "pilot" && "active"} rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setTestContest("isu")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">ISU</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieTest === "isu" && "active"} rounded-full`}></div>
                                    </div>
                                    <span className="textSemiBold text-black dark:text-white text-[1vw] mt-[2%]">Numele testerului:</span>
                                    <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                        <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                            <input
                                                type="text"
                                                placeholder="..."
                                                value={testerName}
                                                onChange={(e) => setTesterName(e.target.value)}
                                                className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                            />
                                        </div>
                                    </div>
                                    <span className="textSemiBold text-black dark:text-white text-[1vw] mt-[2%]">Dovada:</span>
                                    <div onClick={() => setContestatieDovada("foto")} className="w-[15%] h-[8%] flex flex-row items-center justify-between mt-[1%]">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">Foto</span>
                                        <div className={`w-[1vw] h-[1vw] ${contestatieDovada === "foto" && "active"} ball rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setContestatieDovada("video")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">Video</span>
                                        <div className={`w-[1vw] h-[1vw] ${contestatieDovada === "video" && "active"} ball rounded-full`}></div>
                                    </div>
                                </div>
                            ) : (
                                <div className="w-full h-[72%] flex flex-col items-center justify-center">
                                    <span className="textSemiBold text-black dark:text-white text-[1vw]">Tipul reclamatiei:</span>
                                    <div onClick={() => setAmendaContestatie("amenda")} className="w-[15%] h-[8%] flex flex-row items-center justify-between mt-[1%]">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">AMENDA</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieAmenda === "amenda" && "active"} rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setAmendaContestatie("avertisment")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">AV</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieAmenda === "avertisment" && "active"} rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setAmendaContestatie("fw")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">FW</span>
                                        <div className={`w-[1vw] h-[1vw] ball ${contestatieAmenda === "fw" && "active"} rounded-full`}></div>
                                    </div>
                                    <span className="textSemiBold text-black dark:text-white text-[1vw] mt-[2%]">Nume membru conducere:</span>
                                    <div className="w-[30%] h-[10%] flex flex-row items-center justify-between mt-[1%]">
                                        <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-full h-full rounded-full flex items-center justify-between box-border px-[1%]">
                                            <input
                                                type="text"
                                                placeholder="..."
                                                value={testerName}
                                                onChange={(e) => setTesterName(e.target.value)}
                                                className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent w-full h-full border-none outline-none text-center"
                                            />
                                        </div>
                                    </div>
                                    <span className="textSemiBold text-black dark:text-white text-[1vw] mt-[2%]">Dovada:</span>
                                    <div onClick={() => setContestatieDovada("foto")} className="w-[15%] h-[8%] flex flex-row items-center justify-between mt-[1%]">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">Foto</span>
                                        <div className={`w-[1vw] h-[1vw] ${contestatieDovada === "foto" && "active"} ball rounded-full`}></div>
                                    </div>
                                    <div onClick={() => setContestatieDovada("video")} className="w-[15%] h-[8%] flex flex-row items-center justify-between">
                                        <span className="textMedium text-black dark:text-white text-[1vw]">Video</span>
                                        <div className={`w-[1vw] h-[1vw] ${contestatieDovada === "video" && "active"} ball rounded-full`}></div>
                                    </div>
                                </div>
                            )}
                            <button onClick={() => sendContestatie()} className="textBold cursor-pointer w-fit h-[13%] pl-[7%] pr-[7%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw]">
                                <span className="text-[1.1vw] text-white">TRIMITE CONTESTATIE</span>
                            </button>
                        </div>
                    </Box>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={activeContestatiiModalOpen}
                    onClose={handleActiveContestatiiClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                    }}
                >
                    <Fade in={activeContestatiiModalOpen}>
                    <Box sx={activeStyle} className="flex flex-col">
                        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">LISTA CONTESTATII ACTIVE</span>
                        <div className="w-[100%] h-full bg-white dark:bg-[#282828] rounded-[0.5vw] flex flex-col gap-[0.5%]">
                            {Array.isArray(activeContestatii) && activeContestatii.length > 0 && (
                                activeContestatii.map((contestatie, index) => (
                                <div key={index} className="w-full min-h-[14%] border-b-[1px] border-grey-500 flex flex-row items-center justify-center box-border px-[2%] gap-[2%]" >
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">[M-{String(contestatie.callsign).padStart(3, '0')}] {getMemberInfo(contestatie.callsign, "full_name")}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{contestatie.tipcontestatie.toUpperCase()}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{contestatie.tip.toUpperCase()}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold min-w-fit text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">{contestatie.nume}</span>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <div onClick={() => deleteContestatie(contestatie.callsign, contestatie.tip, contestatie.tipcontestatie, contestatie.nume)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                        <span className="textBold text-white text-[.8vw]">STERGE</span>
                                    </div>
                                </div>
                            )))}
                        </div>
                    </Box>
                    </Fade>
                </Modal>
            </div>
            <ToastContainer />
        </LocalizationProvider>
    );
}

export default HomePage;
